// src/pages/expense/env/total/ExpenseEnvTotalDraftList.jsx
// ✅ 전 사업 확산 [1] 공통화 — 환경/종합 "지출목록" 페이지. 실제 로직은
// pages/expense/_shared/ExpenseDraftList.jsx(공통 컴포넌트)에 있고, 이 파일은 환경/종합
// 전용 config(envTotalConfig.js)를 넘기는 얇은 래퍼일 뿐이다. 라우트 경로/파일명은
// 리팩터링 전과 동일하게 유지(App.js/protectedRoutes.js 변경 없음).
import React from "react";
import ExpenseDraftList from "../../_shared/ExpenseDraftList";
import envTotalConfig from "./envTotalConfig";

export default function ExpenseEnvTotalDraftList() {
  return <ExpenseDraftList config={envTotalConfig} />;
}
